import Evented from './Evented';
const CHANNEL_PASSTHROUGH = [
    'connected', 'failed', 'reconnecting', 'up', 'down', 'switching', 'error', 'message', 'destroy'
];
/**
 * Abstracts the shared/common IChannel for a unique client
 * so that events can easily be tracked and unbound when needed
 */
export default class UniqueChannelInstance extends Evented {
    constructor(channel) {
        super();
        this.channel = channel;
        CHANNEL_PASSTHROUGH.forEach((eventName) => {
            this.listenTo(this.channel, eventName, (...args) => {
                this.emit(eventName, ...args);
            });
        });
        this.off = (event, handler) => {
            if (event) {
                if (handler) {
                    this.removeListener(event, handler);
                }
                else {
                    this.removeAllListeners(event);
                }
            }
            else {
                this.removeAllListeners();
            }
            return this;
        };
        this.fireInitialConnectionEvents();
    }
    unsubscribe() {
        if (this.channel) {
            this.channel.unsubscribe();
            this.stopListening(this.channel);
            this.removeAllListeners();
            delete this.channel;
        }
    }
    // The channel may already be connected if we re-use it
    // so fire initial connection events if that was the case
    fireInitialConnectionEvents() {
        if (this.channel.isConnected) {
            setTimeout(() => {
                if (this.channel && this.channel.isConnected) {
                    this.emit('connected');
                    this.emit('up');
                }
                else {
                    this.emit('failed', 'channel removed');
                }
            }, 0);
        }
    }
}
//# sourceMappingURL=UniqueChannelInstance.js.map